/**
 * URL base del microservicio yoolpay (repo payment).
 *
 * SIEMPRE same-origin: el browser llama a /api/yoolpay/* y la Vercel Function
 * api/yoolpay/[...path].js reenvía server-side a YOOLPAY_SERVICE_URL con el
 * x-vercel-protection-bypass. Llamar a yoolpay.dev directo desde el browser NO
 * funciona: los dominios custom de preview están tras el SSO de Vercel y el
 * preflight CORS muere en 302. Same-origin además elimina CORS por completo y
 * el mapeo dev→dev / prod→prod vive en UNA env server-side por entorno
 * (YOOLPAY_SERVICE_URL, convención yool-env-conventions).
 *
 * `REACT_APP_YOOLPAY_URL` queda solo como override para desarrollo local
 * (ej. payment corriendo en http://localhost:3005) — no definirla en Vercel.
 */
export function yoolpayBaseUrl() {
  const override = process.env.REACT_APP_YOOLPAY_URL;
  if (override) return override.replace(/\/$/, '');
  return '/api/yoolpay';
}
